import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import './control-bar.scss';

export default class ControlBar extends Component {
  flipCard = () => this.props.flipCard();
  getNextCard = () => this.props.nextCard();
  restartApp = () => this.props.restartApp();
  contactUs = () => window.location.href = this.props.contactUsUrl;
  checkIfLastCard = () => !this.props.cardId ? true : false;

  getControlButtons = () => {
    const buttons = [];
    if (!this.checkIfLastCard()) {
      buttons.push(this.getFlipCardBtn());
      buttons.push(this.getNextCardBtn());
    } else {
      buttons.push(this.getRestartBtn());
      buttons.push(this.getContactUsBtn());
    }
    return buttons;
  }

  getFlipCardBtn() {
    return (
      <button
        className={`control-btn ${!this.props.isFlipped ? "" : "disabled"}`}
        onClick={this.flipCard}
        disabled={this.props.isFlipped}
        key={0}
      >
        Flip card
      </button>
    )
  }

  getNextCardBtn() {
    return (
      <button
        className={`control-btn ${this.props.isFlipped ? "" : "disabled"}`}
        onClick={this.getNextCard}
        disabled={!this.props.isFlipped}
        key={1}
      >
        Next card
      </button>
    )
  }

  getRestartBtn() {
    return (
      <button className="control-btn" onClick={this.restartApp} key={0}>
        Replay
      </button>
    )
  }

  getContactUsBtn() {
    return (
      <button onClick={this.contactUs} className="control-btn" key={1}>
        Let's talk
      </button>
    )
  }

  render() {
    const controlButtons = this.getControlButtons();

    return (
      <CSSTransition
        in={this.props.isGameStarted}
        timeout={2000}
        classNames='control-bar'
        appear
      >
        <div className="card-control">
          {controlButtons}
        </div>
      </CSSTransition>
    );
  };
};
